export const CATEGORIES = [
  { id: "ehliyet", label: "Ehliyet", subtitle: "Sürücü Kursları", description: "B, A1/A2, C, D, E sınıfı sürücü belgeleri için MEB onaylı sınıflar." },
  { id: "myk", label: "MYK", subtitle: "Mesleki Yeterlilik", description: "Mesleğinizin yasal geçerliliğini sağlayan MYK sertifika programları." },
  { id: "is_makinalari", label: "İş Makinaları", subtitle: "Operatörlük Belgesi", description: "Forklift, ekskavatör, vinç ve daha fazlası için operatörlük kursları." },
];

export const CATEGORY_LABEL = {
  ehliyet: "Ehliyet",
  myk: "MYK",
  is_makinalari: "İş Makinaları",
};

export const STATUS_META = {
  yeni: { label: "Yeni", color: "bg-blue-100 text-blue-800" },
  iletisim: { label: "İletişime Geçildi", color: "bg-amber-100 text-amber-800" },
  kayit: { label: "Kayıt Oldu", color: "bg-emerald-100 text-emerald-800" },
  iptal: { label: "İptal", color: "bg-neutral-200 text-neutral-700" },
};
